// extracted by mini-css-extract-plugin
export default {"root":"_2GXLT","icon":"_1_BU_","title":"_2rZTl","subtitle":"PlI_E","button":"_12AO6"};